module.exports = __webpack_public_path__ + "static/media/background2.c3c367c1.png";